import { render } from "./AccountHistoryView.vue?vue&type=template&id=2b2f7868&scoped=true"
import script from "./AccountHistoryView.vue?vue&type=script&lang=js"
export * from "./AccountHistoryView.vue?vue&type=script&lang=js"

import "./AccountHistoryView.css?vue&type=style&index=0&id=2b2f7868&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2f7868"]])

export default __exports__